/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PatchOrdersOrderIdArchiveMutationResponse, PatchOrdersOrderIdArchivePathParams, PatchOrdersOrderIdArchive400 } from "../entities/PatchOrdersOrderIdArchive";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { patchOrdersOrderIdArchive } from "../api/patchOrdersOrderIdArchive";
import { useMutation } from "@tanstack/react-query";

export const patchOrdersOrderIdArchiveMutationKey = () => [{ url: '/orders/:order_id/archive' }] as const

export type PatchOrdersOrderIdArchiveMutationKey = ReturnType<typeof patchOrdersOrderIdArchiveMutationKey>

/**
 * @description Архивирование заказа
 * @summary Архивирование
 * {@link /orders/:order_id/archive}
 */
export function usePatchOrdersOrderIdArchive<TContext>(options: 
{
  mutation?: UseMutationOptions<PatchOrdersOrderIdArchiveMutationResponse, ResponseErrorConfig<PatchOrdersOrderIdArchive400>, {order_id: PatchOrdersOrderIdArchivePathParams["order_id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchOrdersOrderIdArchiveMutationKey()

  return useMutation<PatchOrdersOrderIdArchiveMutationResponse, ResponseErrorConfig<PatchOrdersOrderIdArchive400>, {order_id: PatchOrdersOrderIdArchivePathParams["order_id"]}, TContext>({
    mutationFn: async({ order_id }) => {
      return patchOrdersOrderIdArchive(order_id, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}